import { solutions, getSolutionNavPath } from './solutions'

export const navMegaMenus = {
  '/solutions': {
    columns: [
      {
        title: '教育行业系统',
        items: solutions
          .filter(s => ['edu-management', 'moral-education', 'online-exam'].includes(s.id))
          .map(s => ({
            title: s.title,
            desc: s.summary.slice(0, 24) + (s.summary.length > 24 ? '...' : ''),
            path: getSolutionNavPath(s.id),
            isNew: s.id === 'edu-management'
          }))
      },
      {
        title: '智能安防系统',
        items: solutions
          .filter(s => s.id === 'ai-security')
          .map(s => ({
            title: s.title,
            desc: s.summary.slice(0, 24) + '...',
            disabled: true,
            isNew: true
          }))
      },
      {
        title: '定制开发服务',
        items: [
          {
            title: '桌面软件开发',
            desc: 'Windows/Linux 上位机与工具软件',
            path: '/solutions',
            isNew: false
          },
          {
            title: 'Web 系统开发',
            desc: '微商城、OA、教务、人才库等',
            path: '/solutions',
            isNew: false
          },
          {
            title: 'APP 开发',
            desc: 'iOS + Android 原生与跨端',
            path: '/solutions',
            isNew: false
          },
          {
            title: '查看全部方案',
            desc: '更多行业解决方案持续更新',
            path: '/solutions',
            isNew: false,
            highlight: true
          }
        ]
      }
    ]
  },
  '/about': {
    columns: [
      {
        title: '了解元码科技',
        items: [
          {
            title: '企业介绍',
            desc: '专注企业数字化软件定制开发',
            path: '/about#intro'
          },
          {
            title: '企业文化',
            desc: '使命、愿景与核心价值观',
            path: '/about#culture'
          }
        ]
      },
      {
        title: '合作案例',
        items: [
          {
            title: '客户案例',
            desc: '15+ 合作伙伴成功案例',
            path: '/about#cases'
          },
          {
            title: '联系我们',
            desc: '武汉东湖高新区 K11 铭丰大厦',
            path: '/contact'
          }
        ]
      }
    ]
  }
}

export function hasNavMegaMenu(path) {
  return Boolean(navMegaMenus[path])
}
